export const isDesktop = () => document.documentElement.clientWidth > 480
